<label
  class="file"
  [class.file--only-button]="displayType === 'only-button'"
  [class.file--full]="displayType === 'full'"
>
  <input #fileInput class="file__input" type="file" [required]="required" (change)="onChange($event)" />

  <span class="file__control">
    <a ftrButton class="file__button" [size]="buttonSize.Small">{{ label }}</a>

    @if (selectedFile) {
      <span class="file__name">{{ selectedFile.name }}</span>
    }
    @if (selectedFile) {
      <span class="file__size">({{ selectedFile.size | ftrFileSize }})</span>
    }

    @if (!selectedFile) {
      <span class="file__placeholder">Choose file</span>
    }
  </span>

  <span
    class="file__validation"
    ftrValidationErrorHint
    [label]="validationLabel"
    [ngFormControl]="ngFormControl"
    [submitAttempted]="submitAttempted"
    [controlTouched]="controlTouched"
  ></span>
</label>
